/**
 * Map content module. Requires GoogleMaps.js
 *
 * @module Map
 * @author EN GARDE
 * @version 1.1
 */

var EN = EN || {};

EN.Map = (function ($, _, GoogleMaps) {
	'use strict';

	var options = {
		selectors: {
			module: '.en-mdl-map',
			map: '.en-mdl-map__map'
		},
		classNames: {
			infoWindow: 'en-mdl-map__info-window en-wysiwyg'
		}
	};

	/**
	 * Initializes a Google Maps map based on data attributes on the module element.
	 * @memberof module:Map
	 */
	var init = function () {
		$(options.selectors.module).each(function () {
			var $module = $(this);
			var $map = $module.find(options.selectors.map);
			var center = $module.attr('data-en-map-center') ? JSON.parse($module.attr('data-en-map-center')) : undefined;
			var markers = $module.attr('data-en-map-markers') ? JSON.parse($module.attr('data-en-map-markers')) : undefined;
			var zoom = parseInt($module.attr('data-en-map-zoom'), 10) || undefined;
			var map;

			// bail if the map was already initialized
			if ($map.data('EnMap')) {
				return;
			}

			map = new GoogleMaps($map, {
				apiKey: EN.config.google_apikey,
				styles: EN.config.google_map_styles,
				center: center,
				zoom: zoom,
				cbScriptLoaded: function (_map) {

					// create markers
					_.each(markers, function (_marker) {
						var marker = _map.addMarker({
							lat: _marker.position.lat,
							lng: _marker.position.lng,
							image: _marker.image || $module.attr('data-en-map-marker-image'),
							url: _marker.url
						});

						if (_marker.text) {
							_map.addInfoWindow(marker, '<div class="' + options.classNames.infoWindow + '">' + _marker.text + '</div>');
						}
					});

					// fit to marker bounds if there are markers and no center was specified
					if (markers && !center) {
						_map.fitToMarkerBounds(zoom);
					}
				}
			});

			$map.data('EnMap', map);
		});
	};

	// exports
	return {
		init: init
	};
}(jQuery, lodash, EN.GoogleMaps));
